module.exports = __webpack_public_path__ + "assets/fa3e78f0e63d944240161f3a91d2f8d8.png";